
import './StoreBook.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FaTag } from 'react-icons/fa';
import StoreBookSidebar from './StoreBookSidebar';
import StoreBookMain from './StoreBookMain';
import StoreBookInsert from './StoreBookInsert';

const StoreBook = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [selectedChildCode, setSelectedChildCode] = useState(null);
  const [bookCategories, setBookCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showInsert, setShowInsert] = useState(false);

 
  useEffect(() => {
    // 서버에서 교재 카테고리 목록 가져오기
    fetchStoreBookList();
  }, []);



   const fetchStoreBookList = () => {
    setIsLoading(true);
    fnc.sendAxios('/storeBookRoutes/select/storeBookList', {}, (res) => {
      if (res && res.length > 0) {
        const grouped = groupDataByParent(res);
        setBookCategories(grouped);
        
        // 첫 번째 카테고리의 첫 번째 자식을 기본 선택
        if (grouped.length > 0) {
          setSelectedMenu(grouped[0].parent_code);
          if (grouped[0].children.length > 0) {
            setSelectedChildCode(grouped[0].children[0].child_code);
          }
        }
      }
      setIsLoading(false);
    });
  };

  const groupDataByParent = (data) => {
    const parentMap = new Map();
    
    data.forEach(item => {
      if (!parentMap.has(item.parent_code)) {
        parentMap.set(item.parent_code, {
          parent_sno: item.parent_sno,
          parent_code: item.parent_code,
          parent_unit: item.parent_unit,
          grade: item.grade,
          icon: getIconByGrade(item.grade),
          children: []
        });
      }
      
      // child_sno가 NULL이 아닌 경우만 children에 추가
      if (item.child_sno !== 'NULL' && item.child_sno !== null) {
        parentMap.get(item.parent_code).children.push({
          child_sno: item.child_sno,
          child_code: item.child_code,
          child_unit: item.child_unit,
          child_sort: item.child_sort
        });
      }
    });
    
    return Array.from(parentMap.values()).sort((a, b) => a.parent_sno - b.parent_sno);
  };

  const getIconByGrade = (grade) => {
    // 부모 메뉴는 모두 FaTag로 통일
    return <FaTag />;
  };

  const handleChildMenuClick = (parentCode, childCode) => {
    setSelectedMenu(parentCode);
    setSelectedChildCode(childCode);
  };

  function fncShowInsertClick() {
    const isHeadOffice = fnc.getCookie('acaCode');
    if (!isHeadOffice || isHeadOffice !== '2000') {
      alert('본사 계정만 교재 등록이 가능합니다.');
      return;
    }
 
    setShowInsert(true);
  }

//=========================================
  return (
  <S.Section>
    <div className='StoreBook'>
        {showInsert ? (
          <StoreBookInsert onBack={() => setShowInsert(false)} />
        ) : isLoading ? (
          <div style={{ padding: '50px', textAlign: 'center' }}>
            <p>데이터 로딩 중...</p>
          </div>
        ) : bookCategories.length === 0 ? (
          <div style={{ padding: '50px', textAlign: 'center' }}>
            <p>카테고리 데이터가 없습니다.</p>
          </div>
        ) : (
        <div className="store-layout">
          <StoreBookSidebar
            bookCategories={bookCategories}
            selectedMenu={selectedMenu}
            selectedChildCode={selectedChildCode}
            onChildMenuClick={handleChildMenuClick}
          />
          
          <StoreBookMain
            bookCategories={bookCategories}
            selectedMenu={selectedMenu}
            selectedChildCode={selectedChildCode}
            onShowInsert={fncShowInsertClick}
          />
        </div>
        )}
    </div>
  </S.Section>
  );
};

export default StoreBook;